<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <admin-side-bar
        :sidebar-item-color="sidebarBackground"
        :sidebar-background-image="sidebarBackgroundImage"
    >
      <mobile-menu slot="content"></mobile-menu>

      <sidebar-link to="/admin">
        <md-icon>dashboard</md-icon>
        <p>Dashboard</p>
      </sidebar-link>

      <div @click="toggleDropdown('listings')" class="parent-link">
        <md-icon>list</md-icon>
        <p class="link_text">Listings</p>
        <md-icon class="dropdown-icon">
          {{ dropdowns.listings ? 'expand_less' : 'expand_more' }}
        </md-icon>
      </div>
      <div v-if="dropdowns.listings" class="sub-links">
        <sidebar-link to="/admin/create_listing">
          <md-icon>list</md-icon>
          <p>Create Listing</p>
        </sidebar-link>
        <sidebar-link to="/admin/listings">
          <md-icon>list</md-icon>
          <p>Listings</p>
        </sidebar-link>
        <sidebar-link to="/admin/drafts">
          <md-icon>list</md-icon>
          <p>Drafts</p>
        </sidebar-link>
      </div>

      <sidebar-link to="/admin/reservations">
        <md-icon>event_available</md-icon>
        <p>Reservations</p>
      </sidebar-link>

      <sidebar-link to="/admin/blogs">
        <md-icon>comment</md-icon>
        <p>Blogs</p>
      </sidebar-link>

      <sidebar-link to="/admin/reviews">
        <md-icon>reviews</md-icon>
        <p>Reviews</p>
      </sidebar-link>

      <sidebar-link to="/admin/subscribes">
        <md-icon>dynamic_feed</md-icon>
        <p>subscribes</p>
      </sidebar-link>

      <div @click="toggleDropdown('contacts')" class="parent-link">
        <md-icon>groups</md-icon>
        <p class="link_text">Contacts</p>
        <md-icon class="dropdown-icon">
          {{ dropdowns.contacts ? 'expand_less' : 'expand_more' }}
        </md-icon>
      </div>
      <div v-if="dropdowns.contacts" class="sub-links">
        <sidebar-link to="/admin/contacts">
          <md-icon>group</md-icon>
          <p>Contacts</p>
        </sidebar-link>
        <sidebar-link to="/admin/blocked_contacts">
          <md-icon>person_off</md-icon>
          <p>Blocked Contacts</p>
        </sidebar-link>
      </div>
      <sidebar-link to="/admin/tags">
        <md-icon>tag</md-icon>
        <p>Tags</p>
      </sidebar-link>

      <sidebar-link to="/admin/amenities">
        <md-icon>wifi</md-icon>
        <p>Amenities</p>
      </sidebar-link>

    </admin-side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <fixed-plugin
          :color.sync="sidebarBackground"
          :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin>
      <dashboard-content> </dashboard-content>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import DashboardContent from "./Content.vue";
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import FixedPlugin from "@/pages/Layout/Extra/FixedPlugin";
import MobileMenu from "@/pages/Layout/MobileMenu";
export default {
  name: "AdminLayout",
  data() {
    return {
      sidebarBackground: "green",
      sidebarBackgroundImage: require("@/assets/img/sidebar-2.jpg"),
      dropdowns: {
        listings: false,
        contacts: false,
      },
    }
  },
  components: {
    DashboardContent,
    ContentFooter,
    TopNavbar,
    FixedPlugin,
    MobileMenu,
  },
  methods: {
    toggleDropdown(menu) {
      this.dropdowns[menu] = !this.dropdowns[menu];
    }
  }
}
</script>

<style scoped lang="scss">
.parent-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 8px 20px 2px;
  padding: 10px 15px;
  & .link_text {
    color: #fff;
    line-height: 30px;
    font-size: 14px;
    font-weight: 300;
  }
  ::v-deep i {
    margin-right: 5px !important;
  }
  &:hover {
    background-color: rgba(200, 200, 200, 0.2);
  }
}
.sub-links {
  padding-left: 24px;
}
.dropdown-icon {
  font-size: 20px;
}
</style>
